module.exports = __webpack_public_path__ + "img/Vector_40_1213.6108ab1a.png";